import React from "react";
import Popover from "@material-ui/core/Popover";
import Draggable from "react-draggable";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useEmojiPicker } from "../contexts/EmojiPickerContext";


export default function EmojiPicker({ onSelect }) {

  const {emojiPickerOpen, setEmojiPicker} = useEmojiPicker()
  return (
    <div>
      <Draggable>
        <Popover
          id="emoji-picker"
          open={Boolean(emojiPickerOpen)}
          anchorEl={emojiPickerOpen}
          onClose={() => setEmojiPicker(null)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Picker
            onSelect={onSelect}
            set="facebook"
            showPreview={false}
            title={null}
            showSkinTones={false}
          />
        </Popover>
      </Draggable>
    </div>
  );
}
